import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
//#endregion
//#region components
import ManageAssistantsContainer, { ManageAssistantsHandle } from "./manageAssistantsContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

interface DisplayParams {
  financialYearId: number;
  period: string;
  availableAuditors: WintSuperkollAPIModelAnnualAccounts.AuditorAssistantOption[];
  initialAssistants: WintSuperkollAPIModelAnnualAccounts.AuditorAssistantOption[];
  onSaved: () => void;
}

function useManageAssistantsDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const displayManageAssistantsDialog = ({
    financialYearId,
    period,
    availableAuditors,
    initialAssistants,
    onSaved,
  }: DisplayParams) => {
    const containerRef = React.createRef<ManageAssistantsHandle>();
    dispatch(
      displayDialog({
        isOpen: false,
        title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.ManageAssistants),
        subTitle: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Reports.AssistantsSubtitle,
          undefined,
          { period }
        ),
        titleIcon: IconDefinitionConstants.WUsers,
        dialogType: DialogEnums.DialogType.Content,
        actions: [
          {
            text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Save),
          },
        ],
        onSubmit: async () => {
          await containerRef.current?.submit();
        },
        children: (
          <ManageAssistantsContainer
            ref={containerRef}
            financialYearId={financialYearId}
            availableAuditors={availableAuditors}
            initialAssistants={initialAssistants}
            onSaved={onSaved}
          />
        ),
        maxWidth: "sm",
      })
    );
  };

  return { displayManageAssistantsDialog };
}

export default useManageAssistantsDialog;
